<template>
    <div class="life-proposal-body">
        <div class="life-proposal-title">
            海外巣ごもり生活新提案
        </div>
        <div class="life-proposal-msg">
            Kaiteki TVは時間も場所も端末も選びません!<br/>
            日本よりも快適で贅沢なテレビライフをあなたに!
        </div>
        <div class="life-proposal-carousel">
            <a-carousel :after-change="onChange" autoplay>
                <div class="carousel-inset" v-for="(n, index) in lifeProposalList" :key="index">
                    <img :src="n.image" />
                    <div class="carousel-title">
                        {{ n.title }}
                    </div>
                    <div class="carousel-msg">
                        {{ n.msg }}
                    </div>
                </div>
            </a-carousel>
        </div>
    </div>
</template>
<script>
import lifeProposalList from '../../../images/life-proposal'
export default {
    data () {
        return {
            lifeProposalList
        }
    }
}
</script>
<style scoped>
.ant-carousel >>> .slick-slide {
  text-align: center;
  height: 460px;
  background: #F3F3F3;
  overflow: hidden;
}
.life-proposal-body {
    text-align: center;
    padding-top: 60px;
    width: 100%;
    background: #F3F3F3;
    padding-bottom: 30px;
}
.life-proposal-msg {
    font-size: 14px;
    font-family: Kozuka Gothic Pr6N;
    font-weight: normal;
    color: #000000;
}
.life-proposal-title {
    font-size: 26px;
    font-family: A-OTF Gothic MB101 Pr5;
    font-weight: normal;
    color: #000000;
    line-height: 13px;
    font-weight: bold;
    margin-bottom: 30px;
}
.life-proposal-carousel {
    width: 100%;
    box-sizing: border-box;
    padding: 20px;
    overflow: hidden;
}
/**
 *重写css
 */
* >>> .ant-carousel .slick-dots li button {
    width: 9px;
    height: 9px;
    background: #DADADA;
    border-radius: 9px;
    opacity: 1;
}
* >>> .ant-carousel .slick-dots li.slick-active button {
    width: 15px;
    height: 9px;
    background: #FDB819;
}
.carousel-inset img {
    display: block;
    width: 100%;
}
.carousel-title {
    position: relative;
    width: 100%;
    box-sizing: border-box;
    padding-left: 35px;
    font-size: 13.5px;
    font-family: Kozuka Gothic Pr6N;
    font-weight: normal;
    color: #000000;
    line-height: 25px;
    font-weight: bold;
    margin-top: 10px;
    margin-bottom: 10px;
    text-align: left;
}
.carousel-title::before {
    content: '';
    height: 80px;
    position: absolute;
    display: inline-block;
    border:solid 5px #fff;
    background: #FDB819;
    width: 40px;
    left: -5px;
    top: -30px;
}
.carousel-msg {
    font-size: 14px;
    font-family: Kozuka Gothic Pr6N;
    font-weight: normal;
    color: #000000;
    line-height: 24px;
    text-align: left;
    justify-content: space-between;
}
</style>